// extracted by mini-css-extract-plugin
export default {"title":"WindowTop_title__DC9aU","strokes":"WindowTop_strokes__AAwkj"};